// Copyright © 2021 Move Closer
import { abstractLinkProps } from '../../_abstract';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapLinkProps = abstractLinkProps;
